import React from "react";
import { useStats } from "./useStats";
import {
  formatAvailableCruisesPlural,
  formatCruisesPlural
} from "src/utils/common-plurals";
import { useCurrentRefinements } from "react-instantsearch";

export const CruiseStats = () => {
  const { nbHits } = useStats();
  const { items } = useCurrentRefinements();
  const isAvailable =
    items.find((x) => x.attribute === "available") !== undefined;

  return (
    <React.Fragment>
      {isAvailable
        ? formatAvailableCruisesPlural(nbHits)
        : formatCruisesPlural(nbHits)}
    </React.Fragment>
  );
};
